"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptBytes = exports.encryptAES = exports.decrypt = exports.encryptMessage = exports.decryptMessage64 = exports.decryptMessage = exports.bytesToWords = exports.wordsToUtf8 = exports.wordsToBase58 = exports.wordsToBytes = exports.decryptAES64 = exports.decryptAES = exports.passwordAES = exports.getPassword = void 0;
var tweetnacl_1 = require("tweetnacl");
var Base58_1 = require("./Base58");
var SHA256_1 = require("./SHA256");
var convert_1 = require("./convert");
var base64_1 = require("../../src/core/util/base64");
var ed2curve = require('./ed2curve');
var CryptoJS = require('crypto-js');
/** @description Gets share key.
 * @param {Int8Array | string} publicKey The public key.
 * @param {Int8Array | string} privateKey The private key.
 * @return {Promise<Uint8Array>}
 */
exports.getPassword = function (publicKey, privateKey) { return __awaiter(void 0, void 0, void 0, function () {
    var key, _a, _b, _c, secret, _d, _e, _f, theirDHPublicKey, myDHSecretKey, password;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                if (!(typeof publicKey === 'string')) return [3 /*break*/, 2];
                _c = (_b = Buffer).from;
                return [4 /*yield*/, Base58_1.Base58.decode(publicKey)];
            case 1:
                _a = _c.apply(_b, [_g.sent()]);
                return [3 /*break*/, 3];
            case 2:
                _a = Buffer.from(publicKey);
                _g.label = 3;
            case 3:
                key = _a;
                if (!(typeof privateKey === 'string')) return [3 /*break*/, 5];
                _f = (_e = Buffer).from;
                return [4 /*yield*/, Base58_1.Base58.decode(privateKey)];
            case 4:
                _d = _f.apply(_e, [_g.sent()]);
                return [3 /*break*/, 6];
            case 5:
                _d = Buffer.from(privateKey);
                _g.label = 6;
            case 6:
                secret = _d;
                theirDHPublicKey = ed2curve.convertPublicKey(key);
                myDHSecretKey = ed2curve.convertSecretKey(secret);
                password = SHA256_1.default.digest(tweetnacl_1.scalarMult(myDHSecretKey, theirDHPublicKey));
                return [2 /*return*/, password];
        }
    });
}); };
/** @description Gets share key at word array type.
 * @param {Int8Array | string} publicKey The public key.
 * @param {Int8Array | string} privateKey The private key.
 * @return {Promise<Words>}
 */
exports.passwordAES = function (publicKey, privateKey) { return __awaiter(void 0, void 0, void 0, function () {
    var password;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.getPassword(publicKey, privateKey)];
            case 1:
                password = _a.sent();
                return [2 /*return*/, CryptoJS.lib.WordArray.create(password)];
        }
    });
}); };
/** @description Decrypt byte array.
 * @param {Int8Array | string} encryptedMessage Encrypted text to decrypt.
 * @param {Words} secret32 Shared secret.
 * @param {boolean} prefix Exists prefix.
 * @return {Words | boolean}
 */
exports.decryptAES = function (encryptedMessage, secret32, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, arrayMessage, words;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
                    arrayMessage = encryptedMessage;
                    if (!(typeof encryptedMessage === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, Base58_1.Base58.decode(encryptedMessage)];
                case 1:
                    arrayMessage = _a.sent();
                    _a.label = 2;
                case 2:
                    if (prefix) {
                        arrayMessage = arrayMessage.slice(1);
                    }
                    words = CryptoJS.lib.WordArray.create(arrayMessage);
                    return [2 /*return*/, CryptoJS.AES.decrypt({ ciphertext: words }, secret32, { iv: iv })];
            }
        });
    });
};
/** @description Decrypt byte array.
 * @param {Int8Array | string} encryptedMessage Encrypted text to decrypt.
 * @param {Words} secret32 Shared secret.
 * @param {boolean} prefix Exists prefix.
 * @return {Words | boolean}
 */
exports.decryptAES64 = function (encryptedMessage, secret32, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, arrayMessage, words;
        return __generator(this, function (_a) {
            iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
            arrayMessage = encryptedMessage;
            if (typeof encryptedMessage === 'string') {
                arrayMessage = base64_1.default.decodeToByteArray(encryptedMessage);
            }
            if (prefix) {
                arrayMessage = arrayMessage.slice(1);
            }
            words = CryptoJS.lib.WordArray.create(arrayMessage);
            return [2 /*return*/, CryptoJS.AES.decrypt({ ciphertext: words }, secret32, { iv: iv })];
        });
    });
};
exports.wordsToBytes = function (words) {
    return convert_1.hexToBytes(CryptoJS.enc.Hex.stringify(words));
};
exports.wordsToBase58 = function (words) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Base58_1.Base58.encode(exports.wordsToBytes(words))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.wordsToUtf8 = function (words) {
    return words.toString(CryptoJS.enc.Utf8);
};
exports.bytesToWords = function (bytes) {
    return CryptoJS.lib.WordArray.create(new Uint8Array(bytes));
};
/** @description Decrypt text.
 * @param {string} encryptedMessage Encrypted text to decrypt.
 * @param {Int8Array | string} publicKey The public key.
 * @param {Int8Array | string} privateKey The private key.
 * @param {boolean} prefix Exists prefix.
 * @return {Promise<string | boolean>}
 */
exports.decryptMessage = function (encryptedMessage, publicKey, privateKey, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, sharedKey, decrypted, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
                    return [4 /*yield*/, exports.passwordAES(publicKey, privateKey)];
                case 1:
                    sharedKey = _a.sent();
                    return [4 /*yield*/, exports.decryptAES(encryptedMessage, sharedKey, prefix)];
                case 2:
                    decrypted = _a.sent();
                    return [2 /*return*/, exports.wordsToUtf8(decrypted)];
                case 3:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
};
/** @description Decrypt text.
 * @param {string} encryptedMessage Encrypted text to decrypt.
 * @param {Int8Array | string} publicKey The public key.
 * @param {Int8Array | string} privateKey The private key.
 * @param {boolean} prefix Exists prefix.
 * @return {Promise<string | boolean>}
 */
exports.decryptMessage64 = function (encryptedMessage, publicKey, privateKey, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, sharedKey, decrypted, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
                    return [4 /*yield*/, exports.passwordAES(publicKey, privateKey)];
                case 1:
                    sharedKey = _a.sent();
                    return [4 /*yield*/, exports.decryptAES64(encryptedMessage, sharedKey, prefix)];
                case 2:
                    decrypted = _a.sent();
                    return [2 /*return*/, exports.wordsToUtf8(decrypted)];
                case 3:
                    e_2 = _a.sent();
                    console.log(e_2);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
};
/** @description Encrypt text.
 * @param {string} message Text to encrypt.
 * @param {Int8Array | string} publicKey The public key.
 * @param {Int8Array | string} privateKey The private key.
 * @param {boolean} prefix Exists prefix.
 * @return {Promise<int8Array | boolean>}
 */
exports.encryptMessage = function (message, publicKey, privateKey, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, password, sharedKey, encrypted, int8Array0, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
                    return [4 /*yield*/, exports.getPassword(publicKey, privateKey)];
                case 1:
                    password = _a.sent();
                    sharedKey = CryptoJS.lib.WordArray.create(password);
                    encrypted = CryptoJS.AES.encrypt(message, sharedKey, { iv: iv });
                    int8Array0 = exports.wordsToBytes(encrypted.ciphertext);
                    if (prefix) {
                        return [2 /*return*/, new Int8Array(__spread([0x01], int8Array0))];
                    }
                    else {
                        return [2 /*return*/, int8Array0];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    console.log(e_3);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
};
exports.decrypt = function (str, public1, secret2) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.decryptMessage(str, public1, secret2)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/** @description Encrypt text.
 * @param {string} message Text to encrypt.
 * @param {Int8Array | string} secret32 The shared secret key.
 * @param {boolean} prefix Exists prefix.
 * @return {Promise<Int8Array | boolean>}
 */
exports.encryptAES = function (message, secret32, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var secret, _a, iv, password, sharedKey, encrypted, int8Array0, e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!(typeof secret32 === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, Base58_1.Base58.decode(secret32)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = secret32;
                    _b.label = 3;
                case 3:
                    secret = _a;
                    iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
                    password = new Uint8Array(secret);
                    sharedKey = CryptoJS.lib.WordArray.create(password);
                    encrypted = CryptoJS.AES.encrypt(message, sharedKey, { iv: iv });
                    int8Array0 = exports.wordsToBytes(encrypted.ciphertext);
                    if (prefix) {
                        return [2 /*return*/, new Int8Array(__spread([0x01], int8Array0))];
                    }
                    else {
                        return [2 /*return*/, int8Array0];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_4 = _b.sent();
                    console.log(e_4);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
};
/** @description Encrypt text.
 * @param {Int8Array} message Text to encrypt.
 * @param {WordArray} secret32 The shared secret key.
 * @param {boolean} prefix Add one byte to begin.
 * @return {Promise<Int8Array>}
 */
exports.encryptBytes = function (message, secret32, prefix) {
    if (prefix === void 0) { prefix = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var iv, words, encrypted, int8Array0;
        return __generator(this, function (_a) {
            iv = CryptoJS.enc.Hex.parse('06040308010201020702030805070101');
            words = CryptoJS.enc.Hex.parse(convert_1.bytesToHex(message));
            encrypted = CryptoJS.AES.encrypt(words, secret32, { iv: iv });
            int8Array0 = exports.wordsToBytes(encrypted.ciphertext);
            if (prefix) {
                return [2 /*return*/, new Int8Array(__spread([0x01], int8Array0))];
            }
            else {
                return [2 /*return*/, int8Array0];
            }
            return [2 /*return*/];
        });
    });
};
